export const SITE_NAV_LINK_FONT_SIZE = 14;

/** Extra space below sticky nav on public pages (Teams, Fixtures, Results, Rules, etc.). */
export const PUBLIC_PAGE_CONTENT_PT = { base: 6, md: 8 };

/** Sticky site nav shell height (py={2} + h={16}). Use as `top` for secondary sticky bars. */
export const SITE_NAV_STICKY_HEIGHT = '5rem';

/** Nav shell: in document flow (sticky), not fixed over content. */
export const siteNavShellProps = {
  position: 'sticky' as const,
  top: 0,
  zIndex: 10,
  width: 'full',
};

export const siteNavAccountButtonProps = {
  size: 'sm' as const,
  fontSize: SITE_NAV_LINK_FONT_SIZE,
  fontWeight: 500,
  h: 8,
  px: 3,
};
